// The rules pages (server/routes/pages.js, server/rules/content/README.md "URLs"): one illustrated page
// per game family and language. Polish keeps the SEO URLs /zasady/<slug>; every other game language is
// /<code>/rules/<family>. The in-game Rules button and the Games window's "more" link open it in a new
// tab (owner 2026-10-16: no in-game rules window any more), so the game in progress is kept.
import { env } from '../env';
import { currentLanguage } from '../i18n';

export type RulesFamily = 'klondike' | 'double-klondike' | 'spider' | 'forty-thieves' | 'freecell' | 'pyramid' | 'mahjong' | 'mahjong-connect' | 'hearts' | 'makao' | 'three-five-eight' | 'thousand' | 'kulki';

const PL_SLUG: Record<RulesFamily, string> = {
  klondike: 'pasjans-klondike',
  'double-klondike': 'podwojny-klondike',
  spider: 'pasjans-pajak',
  'forty-thieves': 'czterdziestu-rozbojnikow',
  freecell: 'freecell',
  pyramid: 'pasjans-piramida',
  mahjong: 'pasjans-mahjong',
  'mahjong-connect': 'mahjong-connect',
  // not a solitaire: no "pasjans-" (owner 2026-10-26)
  hearts: 'kierki',
  makao: 'makao',
  'three-five-eight': '3-5-8',
  thousand: 'tysiac',
  // not a card game (2026-11-03); the page comes with the add-solitaire-rules step
  kulki: 'kulki',
};

/** `klondike:turn-three` -> `klondike`, `spider:two-suits` -> `spider`, `forty-thieves` -> itself. */
export const rulesFamily = (gameId: string): RulesFamily => {
  const base = gameId.split(':')[0];
  return base === 'double-klondike' || base === 'spider' || base === 'forty-thieves' || base === 'freecell' || base === 'pyramid' || base === 'mahjong' || base === 'mahjong-connect' || base === 'hearts' || base === 'makao' || base === 'three-five-eight' || base === 'thousand' || base === 'kulki' ? base : 'klondike';
};

export function rulesUrl(gameId: string, lang: string = currentLanguage()): string {
  const family = rulesFamily(gameId);
  const path = lang === 'pl-pl' ? `zasady/${PL_SLUG[family]}` : `${lang}/rules/${family}`;
  return `${env.fullAddr.replace(/\/?$/, '/')}${path}`;
}

/** Opens the rules page of a game in a new tab (from a click handler, so no pop-up blocker). */
export function openRules(gameId: string): void {
  window.open(rulesUrl(gameId), '_blank', 'noopener');
}
